import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetCategories_categoryId_ProductAttributes =
  "/categories/:categoryId/product-attributes";

export type ParamsGetCategories_categoryId_ProductAttributes =
  ExtractRouteParams<typeof RouteGetCategories_categoryId_ProductAttributes>;

// `null` means "no value for this product", never "attribute unknown". `''` is
// normalised to `null` server-side.
export type ProductAttributeValue = string | number | boolean | null;

/**
 * The merchandising attributes CDT Studio infers a category spine from.
 *
 * Attribute keys are data, not contract — they come from the category's own
 * source and must be discovered at runtime, never hardcoded. Every product in a
 * response carries the same key set (with `null` where it has no value), and
 * those keys are stable for a category across calls. An absent key means the
 * category has no such attribute at all.
 */
export interface CategoryProductAttributes {
  productCode: string;
  name: string | null;
  attributes: Record<string, ProductAttributeValue>;
}

/**
 * Not paginated: the whole category answers in one response, one (deterministic)
 * row per `productCode`. Products whose attributes are all `null` are still
 * returned — that absence is what the consumer is hunting for.
 */
export interface ResponseGetCategories_categoryId_ProductAttributes {
  categoryId: number;
  products: CategoryProductAttributes[];
}
